import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import { CircleCheckBig, IndianRupee, LinkIcon, MoveLeftIcon, MoveRightIcon } from "lucide-react";
import axios from "axios";
import { ErrorMessage, Field, Form, Formik } from "formik";
import states from "../state.json"
import * as Yup from "yup";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import { useTheme } from "../../utils/theme";
import axiosInstance from "../../api/axiosInstance";
import { useDocumentTitle } from "../../utils/Common";
import { DIGIO_ENV, APP_URL, V1_API_ORIGIN } from "../../config/constants.config";
import { getCashfree } from "../../utils/cashfree";
import { cancelSignDocument, digioSignedUpdatePayment, paymentOnCashFree, requestSignDocument } from "../../api/pricing";
import Layout from '../layout/Layout';
import { activeServices, checkPaymentService } from "../../api/subscription/Subscription.service";
export default function Kyc() {
  const [paymentId, setPaymentId] = useState(localStorage.getItem("pid") || null);
  const buttonRef = useRef(null);
  const navigate = useNavigate();
  const authState = useSelector((state) => state.auth.authState);
  const [hasKycData, setHasKycData] = useState({});
  const [hasPaymentId, setHasPaymentId] = useState(paymentId);
  const [isLastPaymentSuccess, setIsLastPaymentSuccess] = useState(false);
  const [PaymentData, setPaymentData] = useState(null)
  const userDetail = useSelector((state) => state.auth.userDetail);
  // console.log(userDetail);

  const [hasErrorMessage, setHasErrorMessage] = useState();
  const panCardRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
  const [activeShow, setActiveShow] = useState(false);
  const [showkyc, setShowkyc] = useState(false);
  const [showKycForm, setShowKycForm] = useState(false);
  const [kycInfo, setKycInfo] = useState(null);
  const [ShowLoader, setShowLoader] = useState(false);
  const [VerifyOtp, setVerifyOtp] = useState(false);
  const [fallbackFlow, setFallbackFlow] = useState(false);
  const [ShowModal, setShowModal] = useState(false);
  const [RequestId, setRequestId] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [requestSignData, setRequestSignData] = useState({});
  const [data, setData] = useState(null);
  const [digioSignUpdate, setDigioSignUpdate] = useState({
    status: "",
    details: {},
  });
  const [InitializeCashfree, setInitializeCashfree] = useState(false);
  const [paymentLoading, setPaymentLoading] = useState(true);
  const token = localStorage.getItem("suat");
  const getStoredJson = (key) => {
    try {
      const value = localStorage.getItem(key);
      return value ? JSON.parse(value) : null;
    } catch {
      return null;
    }
  };
  const getSignPayload = () => getStoredJson("czSignPayload") || getStoredJson("cz");
  const primaryThemeButtonClass = "btn";
  const primaryThemeButtonStyle = {
    backgroundColor: "var(--bs-emphasis-color)",
    borderColor: "var(--bs-emphasis-color)",
    color: "var(--bs-body-bg)",
  };
  const storedData = localStorage.getItem("cz");
  // const validationSchemaKyc = Yup.object({
  //   // name: Yup.string()
  //   //   .required("Name is required")
  //   //   .max(255, "Name should be less then 100 characters."),
  //   // mobile: Yup.string()
  //   //   .required("Mobile is required")
  //   //   .max(255, "Mobile should be less then 100 characters."),
  //   // email: Yup.string()
  //   //   .required("Email is required")
  //   //   .max(255, "Email should be less then 100 characters."),
  //   dob: Yup.string()
  //     .required("Date of Birth is required"),
  //   // city: Yup.string()
  //   //   .required("City is required")
  //   //   .max(255, "City should be less then 100 characters."),
  //   // country: Yup.string()
  //   //   .required("Country is required")
  //   //   .max(255, "Country should be less then 100 characters."),
  //   pan: Yup.string()
  //     .required("PAN is required")
  //     .matches(panCardRegex, 'Invalid PAN Card format (e.g., ABCDE1234F)')
  //     .max(255, "PAN must be 10 characters only."),
  //   // address: Yup.string()
  //   //   .required("Address is required")
  //   //   .max(255, "Address should be less then 100 characters."),
  // });
  const validationSchemaKyc = (verifyOtp, fallbackFlow) => {
    let schema = {
      pan: Yup.string()
        .required("PAN is required")
        .matches(panCardRegex, "Invalid PAN Card format (e.g., ABCDE1234F)")
        .length(10, "PAN must be exactly 10 characters"),
      mobile: Yup.string()
        .required("Mobile number is required")
        .matches(/^[6-9]\d{9}$/, "Invalid mobile number"),
      dob: Yup.string().required("Date of Birth is required"),
      name: Yup.string().required("Name is required"),
    };

    if (verifyOtp && !fallbackFlow) {
      schema.otp = Yup.string()
        .required("OTP is required")
        .matches(/^\d{6}$/, "OTP must be 6 digits");
    }

    return Yup.object(schema);
  };
  useDocumentTitle("Kyc");
  useEffect(() => {
    if (typeof window === "undefined") return;

    const uid = localStorage.getItem("uid");

    const initialize = async () => {
      try {
        // CASE 1: No Payment ID
        if (!hasPaymentId) {
          try {
            const kycRes = await axiosInstance.get(
              `${V1_API_ORIGIN}/kyc/get-by-userId/${uid}`
            );

            const kycData = kycRes.data.data;

            setHasKycData(kycData);
            setKycInfo(kycData);

            if (kycData?.isCompleted) {
              // setActiveShow(true);
              setShowkyc(true);
              setShowKycForm(false);
            } else {
              setShowKycForm(true);
              setActiveShow(false);
            }
          } catch (err) {
            setShowKycForm(true);
            setActiveShow(false);
            setHasKycData(null);
          }

          return;
        }

        // CASE 2: Payment ID Exists
        const paymentRes = await checkPaymentService(hasPaymentId);

        const paymentData = paymentRes.data.data;

        setPaymentData(paymentData);

        setIsLastPaymentSuccess(
          paymentData?.digioDocSignStatus === "success" &&
          paymentData?.payStatus === "success"
        );

        try {
          const kycRes = await axiosInstance.get(
            `${V1_API_ORIGIN}/kyc/get-by-userId/${uid}`
          );

          const kycData = kycRes.data.data;

          setHasKycData(kycData);
          setKycInfo(kycData);

          if (
            paymentData?.payStatus === "success" &&
            kycData?.isCompleted
          ) {
            await activeServices(hasPaymentId);

            localStorage.removeItem("pid");
            localStorage.removeItem("pz");
            localStorage.removeItem("cz");

            toast.success("Your Service Activated");
          }

          setActiveShow(true);
          setShowkyc(false);
          setShowKycForm(false);
        } catch (err) {
          setShowKycForm(true);
          setHasKycData(null);
        }
      } catch (error) {
        console.error(error);
      }
    };

    initialize();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const storedData = localStorage.getItem("cz");
        if (storedData) {
          setData(JSON.parse(storedData));
          // handleScrollToTop();
          const planKey = Object.keys(JSON.parse(storedData).planData)[0]; // Get the first key dynamically
          const plan = JSON.parse(storedData).planData[planKey];
          await axiosInstance
            .get(`${V1_API_ORIGIN}/payments?userId=${userDetail.id}&perPage=10&currentPage=1`)
            .then((response) => {
              setPaymentLoading(true);
              const { dataList } = response.data.data;

              // Get FIRST match among all records
              const matchedPayment = dataList.filter((item) => (item.digioDocSignStatus == "success" && item.payStatus == "processing")).find((item) => {
                const paymentCartItem =
                  item.paymentType === "bundle" ? item : item.cartItems[0];
                const isDigioValid = moment(item.digioValidTill).isAfter(moment())
                const isMatch =
                  plan &&
                  isDigioValid &&
                  (item.pacAmount == (plan.discountPrice == 0 ? plan.actualPrice : plan.discountPrice)) &&
                  (paymentCartItem?.name === plan.name || paymentCartItem?.name === plan.bundleName) &&
                  ((paymentCartItem?.paymentType == "bundle" ? paymentCartItem?.cartItems[0].pacDuration : paymentCartItem?.pacDuration) === (plan.bundleName ? plan.duration : plan.planDuration));

                return isMatch;
              });

              // Set paymentId if match
              if (matchedPayment) {
                setPaymentId(matchedPayment.id);
              }

              setPaymentData(!!matchedPayment);
              setPaymentLoading(false);
              // setPaymentId(response.data.data.dataList[0]?.id)
              // const paymentCartItem = response.data.data.dataList[0]?.paymentType == "bundle" ? response.data.data.dataList[0] : response.data.data.dataList[0]?.cartItems[0];
              // const isDigioValid = response.data.data.dataList[0]?.digioValidTill && (moment(response.data.data.dataList[0]?.digioValidTill).isAfter(moment(), 'day') || (moment(response.data.data.dataList[0]?.digioValidTill).isBefore(moment().endOf('day')) && moment(response.data.data.dataList[0]?.digioValidTill).isAfter(moment().startOf('day'))))
              // const isMatch =
              //   plan &&
              //   isDigioValid &&
              //   (paymentCartItem?.name === plan.name || paymentCartItem?.name === plan.bundleName) &&
              //   ((paymentCartItem?.paymentType == "bundle" ? paymentCartItem?.cartItems[0].pacDuration : paymentCartItem?.pacDuration) === (plan.bundleName ? plan.duration : plan.planDuration));
              // setPaymentData(isMatch);
            });
        }
        // else {
        //   navigate("/pricing");
        // }
      } catch (error) {
        console.error("Error loading payment data:", error);
        // navigate("/pricing");
      }
    }

    fetchData();
  }, []);

  useEffect(() => {
    if (typeof requestSignData.id !== "undefined") {
      window.paymentID = requestSignData.paymentId;
      const digio = new window.Digio({
        environment: DIGIO_ENV,
        callback: async (response) => {
          if (
            response.hasOwnProperty("error_code") &&
            response.error_code === "CANCELLED"
          ) {
            setDigioSignUpdate((prevState) => ({
              ...prevState,
              status: "CANCELLED",
              details: { ...response, paymentID: window.paymentID },
            }));
            setShowModal(false);
          } else {
            setDigioSignUpdate((prevState) => ({
              ...prevState,
              status: "SUCCESS",
              details: { ...response, paymentID: window.paymentID },
            }));
            setShowModal(false);
            setShowLoader(true)
          }
        },
        theme: {
          darkColor: "#AB3498",
          secondaryColor: "#000000",
        },
        Is_redirection_approach: false,
        is_iframe: true,
      });
      digio.init();
      digio.submit(
        requestSignData.id,
        requestSignData.signing_parties[0]?.identifier,
        requestSignData.access_token?.id
      );
    }
  }, [requestSignData]);
  useEffect(() => {
    if (digioSignUpdate.status === "SUCCESS") {
      digioSignedUpdatePayment({
        paymentId: digioSignUpdate.details.paymentID,
        digioDesc: "Signed",
        digioDocId: digioSignUpdate.details.digio_doc_id,
        digioDocSignStatus: "success",
      }).then(() => {
        localStorage.setItem("pid", window.paymentID);
        setInitializeCashfree(true);
        setShowModal(false);
        // navigate(`/make-payment`);
        // handleScrollToTop();
        paymentOnCashFree(digioSignUpdate.details.paymentID, data.IsRecurringOptionOpen).then(
          (response) => {
            if (data.IsRecurringOptionOpen) {
              doPayment(response.data?.data?.subscription_session_id, data.IsRecurringOptionOpen);
            } else {
              doPayment(response.data?.data?.payment_session_id);
            }
          }
        );
      });
    } else if (digioSignUpdate.status === "CANCELLED") {
      setInitializeCashfree(false);
      setShowModal(false);

      cancelSignDocument(digioSignUpdate.details.digio_doc_id);
      navigate("/pricing");
    }
  }, [digioSignUpdate.status]);
  const doPayment = async (payId, isRecurringPayment) => {
    const cashfree = await getCashfree();

    if (isRecurringPayment) {
      let checkoutOptions = {
        subsSessionId: payId,
        // redirectTarget: "_blank",
      };
      // cashfree.checkout(checkoutOptions).then((result) => {
      cashfree.subscriptionsCheckout(checkoutOptions).then((result) => {

        if (result.error) {
          // handleScrollToTop();
          navigate("/txn/failure");
          setInitializeCashfree(false);
          // This will be true whenever user clicks on close icon inside the modal or any error happens during the payment
          console.log(
            "User has closed the popup or there is some payment error, Check for Payment Status"
          );
          console.log(result.error);
        }
        if (result.redirect) {

          // setInitializeCashfree(false);
          // This will be true when the payment redirection page couldnt be opened in the same window
          // This is an exceptional case only when the page is opened inside an inAppBrowser
          // In this case the customer will be redirected to return url once payment is completed
          console.log("Payment will be redirected");
        }
        if (result.paymentDetails) {
          localStorage.setItem("pid", window.paymentID ? window.paymentID : paymentId);
          localStorage.removeItem("cz");
          localStorage.removeItem("czSignPayload");
          axiosInstance.post(`${V1_API_ORIGIN}/payments/${window.paymentID ? window.paymentID : paymentId}`, {
            payStatus: "success",
          });
          setInitializeCashfree(false);
          // navigate("/txn/success");
          activeServices(window.paymentID ? window.paymentID : paymentId).then(() => {
            // setIsLastPaymentSuccess(false);
            // setActiveShow(true)
            setShowkyc(false)
            localStorage.removeItem("pid");
            localStorage.removeItem("pz");
            toast.success("Your Service Activated")
            // navigate("/my-services")
          }).catch((err) => {
            alert("Something Went Wrong. Please try again after sometime.")
            // navigate("/checkout")
          });
          // window.location.reload();
          // handleScrollToTop();
          // This will be called whenever the payment is completed irrespective of transaction status
          console.log("Payment has been completed, Check for Payment Status");
          console.log(result.paymentDetails.paymentMessage);
        }
      });
    }
    else {
      let checkoutOptions = {
        paymentSessionId: payId,
        redirectTarget: "_modal",
      };
      cashfree.checkout(checkoutOptions).then((result) => {
        // cashfree.subscriptionsCheckout(checkoutOptions).then((result) => {

        if (result.error) {
          // handleScrollToTop();
          navigate("/txn/failure");
          setInitializeCashfree(false);
          // This will be true whenever user clicks on close icon inside the modal or any error happens during the payment
          console.log(
            "User has closed the popup or there is some payment error, Check for Payment Status"
          );
          console.log(result.error);
        }
        if (result.redirect) {
          setInitializeCashfree(false);
          // This will be true when the payment redirection page couldnt be opened in the same window
          // This is an exceptional case only when the page is opened inside an inAppBrowser
          // In this case the customer will be redirected to return url once payment is completed
          console.log("Payment will be redirected");
        }
        if (result.paymentDetails) {
          localStorage.setItem("pid", window.paymentID ? window.paymentID : paymentId);
          localStorage.removeItem("cz");
          localStorage.removeItem("czSignPayload");
          axiosInstance.post(`${V1_API_ORIGIN}/payments/${window.paymentID ? window.paymentID : paymentId}`, {
            payStatus: "success",
          });
          setInitializeCashfree(false);
          // navigate("/txn/success");
          axiosInstance.get(`${V1_API_ORIGIN}/payments/active-services/${window.paymentID ? window.paymentID : paymentId}`)
          // navigate("/dashboard");
          window.location.reload();
          // handleScrollToTop();
          // This will be called whenever the payment is completed irrespective of transaction status
          console.log("Payment has been completed, Check for Payment Status");
          console.log(result.paymentDetails.paymentMessage);
        }
      });
    }
  };

  const { isDark } = useTheme();
  const primaryButtonStyle = {
    backgroundColor: "var(--bs-emphasis-color)",
    borderColor: "var(--bs-emphasis-color)",
    color: "var(--bs-body-bg)",
  };
  return (
    <>
      <Layout>
        {ShowLoader && (
          <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-25" style={{ zIndex: 1050 }}>
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        )}
        <section className={isDark ? "welcome-hero-dark-section" : "welcome-hero-light"}>
          <div className="container py-5">
            <div className="row g-3 justify-content-center">
              {isLastPaymentSuccess ? (
                <>
                  {showKycForm && (
                    <>
                      <div className={isDark ? "welcome-hero-dark welcome-hero-dark-border col-md-6 card text-center rounded-3" : "welcome-hero-light-section welcome-hero-light-border col-md-6 card text-center rounded-3"}>
                        <div className="card-body">
                          <div className="text-success mb-2"><CircleCheckBig size={40} /></div>
                          {/* <i className="fa-solid fa-circle-check text-success me-1 w-75" ></i> */}
                          <div className="align-items-center">
                            <small className="text-success text-center">
                              Your payment of <b><IndianRupee size={15} />{PaymentData?.paidAmount}</b> was successful. Your Order ID is {PaymentData?.cfPaymentId}.
                            </small>
                          </div>
                          <h4 className="fw-bold mt-2">Activate Your Service Now</h4>
                          {/* <p className="">
                            <small>({PaymentData?.cartItems[0].name || PaymentData?.bundleName} - {PaymentData?.cartItems[0].pacDuration}  {PaymentData?.cartItems[0].durationType})</small>
                          </p> */}
                          <div className="row">
                            <Formik
                              initialValues={{
                                // userId: userDetail.id,
                                // ckycNo: "-",
                                name: userDetail.firstName,
                                // email: userDetail.email,
                                mobile: userDetail.mobile,
                                // dob: userDetail.dob,
                                dob: "",
                                pan: "",
                                otp: "",
                                // address: "",
                                // city: "",
                                // state: "",
                                // country: "INDIA",
                                // isCompleted: true,
                              }}
                              validationSchema={validationSchemaKyc(VerifyOtp, fallbackFlow)}
                              onSubmit={async (values, { setSubmitting }) => {
                                setSubmitting(false);
                                setShowLoader(true);
                                let resp
                                try {
                                  if (!VerifyOtp && !fallbackFlow) {
                                    let searchParams = {
                                      "pan": values.pan,
                                      "mobile": values.mobile,
                                    }
                                    try {
                                      resp = await axiosInstance.post(`${V1_API_ORIGIN}/kyc/send-otp`, searchParams);
                                      setRequestId(resp.data?.data?.request_id)
                                      toast.success("OTP sent successfully");
                                      setShowLoader(false)
                                      setVerifyOtp(true); // switch to OTP flow
                                    } catch (err) {
                                      // FALLBACK: Direct KYC API
                                      const fallbackParams = {
                                        pan: values.pan,
                                        dob: moment(values.dob).format("DD/MM/YYYY"),
                                      };

                                      const res = await axiosInstance.post(
                                        `${V1_API_ORIGIN}/kyc/fetch`,
                                        fallbackParams
                                      );

                                      toast.success("KYC data fetched successfully");
                                      setKycInfo(res.data.data)
                                      setShowkyc(true)
                                      setShowKycForm(false)
                                      setShowLoader(false)
                                      setFallbackFlow(true); // no OTP verification needed
                                      // open digio here

                                    }
                                  } else if (VerifyOtp && !fallbackFlow) {
                                    // STEP 2: VERIFY OTP
                                    let verifyParams = {
                                      userId: userDetail.id,
                                      request_id: RequestId,
                                      otp: values.otp,
                                    };
                                    const res = await axiosInstance.post(
                                      `${V1_API_ORIGIN}/kyc/verify-otp`,
                                      verifyParams,
                                      {
                                        headers: {
                                          "Content-Type": "application/json",
                                          "Authorization": `Bearer ${token}`,
                                        }
                                      }
                                    );

                                    toast.success("KYC verified successfully");
                                    setShowkyc(true)
                                    setKycInfo(res.data.data)
                                    setShowKycForm(false)
                                    setShowLoader(false)
                                    // open digio here
                                  }
                                } catch (err) {
                                  setErrorMessage(err?.response?.data?.message || "Something went wrong");
                                  setShowModal(true);
                                  setShowLoader(false);
                                } finally {
                                  setShowLoader(false);
                                }
                              }}
                              enableReinitialize
                            >
                              {({ isSubmitting, touched, errors, values }) => (
                                <Form>
                                  <div className="row g-3 justify-content-center">
                                    {/* {hasKycData?.id && (
                                    <div className="col-12  text-center bg-secondary-subtle py-2">
                                      Your KYC details are up to date.
                                    </div>
                                  )} */}
                                    <div className="col-md-7">
                                      <small className="d-block text-muted">Name <small>(as per PAN Card)</small></small>
                                      <Field
                                        name="name"
                                        className={`form-control form-control-sm mt-1 ${touched.name && errors.name && "is-invalid"
                                          }`}
                                        value={values.name || ""}
                                      />
                                      <ErrorMessage
                                        name="name"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                    <div className="col-md-6 d-none">
                                      <div className="form-floating mb-3">
                                        <small className="d-block text-muted">Email</small>
                                        <Field
                                          name="email"
                                          className={`form-control form-control-sm mt-1 ${touched.email && errors.email && "is-invalid"
                                            }`}
                                          value={values.email || ""}
                                        />
                                        <ErrorMessage
                                          name="email"
                                          component="div"
                                          className="invalid-feedback"
                                        />
                                      </div>
                                    </div>

                                    <div className="col-md-6 ">

                                      <small className="d-block text-muted me-1">PAN Card Number* <button type="button " className="border-0 btn btn-sm" data-bs-toggle="modal" data-bs-target="#PanKycModal"><i className="fa-solid fa-circle-question ms-1"></i></button></small>
                                      <Field
                                        name="pan"
                                        className={`form-control form-control-sm mt-1 ${touched.pan && errors.pan && "is-invalid"}`}
                                        value={values.pan || hasKycData?.pan || ""}
                                        disabled={VerifyOtp || fallbackFlow}
                                      ></Field>
                                      <ErrorMessage
                                        name="pan"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                  </div>
                                  <div className="row mt-1 g-3 justify-content-center">
                                    <div className="col-md-6">

                                      <small className="d-block text-muted">Mobile *</small>
                                      <Field
                                        name="mobile"
                                        disabled={VerifyOtp || fallbackFlow}
                                        className={`form-control form-control-sm mt-1 ${touched.mobile && errors.mobile && "is-invalid"
                                          }`}
                                        value={values.mobile || ""}
                                      />
                                      <ErrorMessage
                                        name="mobile"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                  </div>
                                  <div className="row mt-1 g-3 justify-content-center">
                                    <div className="col-md-6 ">
                                      <small className="d-block text-muted">Date Of Birth (dd/mm/yyyy)*</small>
                                      <Field
                                        name="dob"
                                        type="date"
                                        disabled={VerifyOtp || fallbackFlow}
                                        className={`form-control form-control-sm mt-1 ${touched.dob && errors.dob && "is-invalid"
                                          }`}
                                        value={values.dob || ""}
                                      />
                                      <ErrorMessage
                                        name="dob"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>

                                    <div className="col-md-6 d-none">
                                      <small className="d-block text-muted">Country</small>
                                      <Field
                                        as="select"
                                        name="country"
                                        className={`form-control form-control-sm mt-1 ${touched.country && errors.country && "is-invalid"
                                          }`}
                                        value={values.country || ""}
                                      >
                                        <option value="">-- Select --</option>
                                        <option value="INDIA">INDIA</option>
                                        <option value="other">OTHER</option>
                                      </Field>
                                    </div>
                                    {["INDIA"].includes(values.country) ? (
                                      <div className="col-md-6 d-none">
                                        <small className="d-block text-muted">State</small>
                                        <Field
                                          as="select"
                                          name="state"
                                          className={`form-control form-control-sm mt-1 ${touched.state && errors.state && "is-invalid"
                                            }`}
                                          value={values.state || ""}
                                        >
                                          <option value="">-- Select --</option>
                                          {states.map((item, index) => (
                                            <option value={item.value} key={index}>
                                              {item.text}
                                            </option>
                                          ))}
                                        </Field>
                                        <ErrorMessage
                                          name="state"
                                          component="div"
                                          className="invalid-feedback"
                                        />
                                      </div>
                                    ) : (
                                      <div className="col-md-6 d-none">
                                        <small className="d-block text-muted">Country</small>
                                        <Field
                                          name="country"
                                          className={`form-control form-control-sm mt-1 ${touched.country &&
                                            errors.country &&
                                            "is-invalid"
                                            }`}
                                          value={values.country || ""}
                                        />
                                        <ErrorMessage
                                          name="country"
                                          component="div"
                                          className="invalid-feedback"
                                        />
                                      </div>
                                    )}

                                    <div className="col-md-6 d-none">
                                      <small className="d-block text-muted">City</small>
                                      <Field
                                        name="city"
                                        className={`form-control form-control-sm mt-1 ${touched.city && errors.city && "is-invalid"
                                          }`}
                                        value={values.city || ""}
                                      />
                                      <ErrorMessage
                                        name="city"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                    {/* </div>
                                              <div className="row"> */}

                                    <div className="col-md-12 d-none">
                                      <small className="d-block text-muted">
                                        Full Address (as per document)
                                      </small>
                                      <Field
                                        name="address"
                                        as="textarea"
                                        rows="2"
                                        className={`form-control form-control-sm mt-1 ${touched.address && errors.address && "is-invalid"
                                          }`}
                                        value={values.address || hasKycData?.address || ""}
                                      ></Field>
                                      <ErrorMessage
                                        name="address"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                  </div>
                                  {/* OTP only if verifyOtp flow */}
                                  {VerifyOtp && !fallbackFlow && (
                                    <div className="row mt-1 g-3 justify-content-center">
                                      <div className="col-md-6 ">
                                        <small className="d-block text-muted">Enter OTP *</small>
                                        <Field
                                          name="otp"
                                          className={`form-control form-control-sm mt-1 ${touched.otp && errors.otp && "is-invalid"
                                            }`}
                                        />
                                        <ErrorMessage
                                          name="otp"
                                          component="div"
                                          className="invalid-feedback"
                                        />
                                      </div>
                                    </div>
                                  )}
                                  {!(userDetail.rpfProfileType && authState) && (
                                    <div className="text-center text-danger ">
                                      <span>
                                        <b>{hasErrorMessage}</b>
                                      </span>
                                      <br />
                                      <Link to="/risk-profile">
                                        Please complete your risk profile first.{" "}
                                        <LinkIcon size={15} />
                                      </Link>
                                    </div>
                                  )}
                                  <div className="col-12 mt-2 text-center">
                                    <div className="py-2">
                                      <small className="d-block d-none"><small className="text-muted">* I confirm that the information provided in this KYC form is true and accurate. I understand that false details may lead to delayed in service activation process. </small></small>
                                      <button
                                        type="submit"
                                        className="btn btn-success btn-md mt-3 "
                                        disabled={
                                          isSubmitting ||
                                          (!userDetail.rpfProfileType && authState)
                                        }
                                      >
                                        {isSubmitting ? "Loading..." : "Continue"}
                                        {/* {!isSubmittin} */}
                                        {/* <i className="bi bi-arrow-right"></i> */}
                                      </button>
                                    </div>
                                  </div>
                                </Form>
                              )}
                            </Formik>
                          </div>
                          OR
                          <p>You can send your KYC at <b>kyc@equitypandit.com</b></p>
                          OR
                          <p>Upload your kyc from <a href="/upload-documents" className="fw-bold"> upload docs</a>.</p>
                        </div>
                      </div>
                    </>
                  )}
                  {showkyc && (
                    <>
                      <div className="col-md-3"></div>
                      <div className={isDark ? "welcome-hero-dark welcome-hero-dark-border col-md-10 card text-center rounded-3" : "welcome-hero-dark welcome-hero-dark-border col-md-10 card text-center rounded-3"}>
                        <div className="card-body">
                          <h4 className="fw-bold mt-2 text-body-emphasis">KYC Details</h4>
                          <p>
                            <small className="fw-semibold d-none">Please confirm your details</small>
                          </p>
                          <div class="row g-4 mb-3">
                            <div className={`d-flex col-sm-6`}>
                              {/* <div className="text-success mt-2 me-2"><img src={`${APP_URL}/assets/img/Name.svg`} className="img-fluid w-75" alt="name" /></div> */}
                              <div className="badge rounded-pill bg-success bg-opacity-10 text-success px-3 py-3 me-2"><i className="fas fa-user"></i></div>
                              <div>
                                <p className="text-secondary small mb-0 text-start">Name</p>
                                <p className="fw-medium mb-0">{kycInfo?.personal_details?.full_name || kycInfo?.name || ""}</p>
                              </div>
                            </div>
                            <div className={`d-flex col-sm-6`}>
                              {/* <div className="text-success mt-2 me-2"><img src={`${APP_URL}/assets/img/Email.svg`} className="img-fluid w-75" alt="name" /></div> */}
                              <div className="badge rounded-pill bg-success bg-opacity-10 text-success px-3 py-3 me-2"><i className="fas fa-envelope"></i></div>
                              <div>
                                <p className="text-secondary small mb-0 text-start">Email</p>
                                <p className="fw-medium mb-0">{kycInfo?.personal_details?.email || userDetail.email}</p>
                              </div>
                            </div>
                            <div className={`d-flex col-sm-6`}>
                              {/* <div className="text-success mt-2 me-2"><img src={`${APP_URL}/assets/img/PAN.svg`} className="img-fluid w-75" alt="name" /></div> */}
                              <div className="badge rounded-pill bg-success bg-opacity-10 text-success px-3 py-3 me-2"><i class="fas fa-address-card"></i></div>
                              <div>
                                <p className="text-secondary small mb-0 text-start">Pan</p>
                                <p className="fw-medium mb-0">{kycInfo?.personal_details?.pan || kycInfo?.pan_details?.pan_number || ""}</p>
                              </div>
                            </div>
                            <div className={`d-flex col-sm-6`}>
                              {/* <div className="text-success mt-2 me-2"><img src={`${APP_URL}/assets/img/DateOfBirth.svg`} className="img-fluid w-75" alt="name" /></div> */}
                              <div className="badge rounded-pill bg-success bg-opacity-10 text-success px-3 py-3 me-2"><i class="fas fa-calendar-alt"></i></div>
                              <div>
                                <p className="text-secondary small mb-0 text-start">Date Of Birth</p>
                                <p className="fw-medium mb-0">{kycInfo?.personal_details?.dob || kycInfo?.pan_details?.dob || ""}</p>
                              </div>
                            </div>
                            <div className={`d-flex col-sm-6`}>
                              {/* <div className="text-success mt-2 me-2"><img src={`${APP_URL}/assets/img/MobileNo.svg`} className="img-fluid w-75" alt="name" /></div> */}
                              <div className="badge rounded-pill bg-success bg-opacity-10 text-success px-3 py-3 me-2"><i class="fas fa-phone-alt"></i></div>
                              <div>
                                <p className="text-secondary small mb-0 text-start">Mobile No</p>
                                <p className="fw-medium mb-0">{kycInfo?.personal_details?.mob_no || userDetail.mobile || ""}</p>
                              </div>
                            </div>
                            <div className={`d-flex col-sm-6`}>
                              {/* <div className="text-success mt-2 me-2"><img src={`${APP_URL}/assets/img/PinCode.svg`} className="img-fluid w-75" alt="name" /></div> */}
                              <div className="badge rounded-pill bg-success bg-opacity-10 text-success px-3 py-3 me-2"><i class="fas fa-map-pin fa-lg"></i></div>
                              <div>
                                <p className="text-secondary small mb-0 text-start">Pin Code</p>
                                <p className="fw-medium mb-0">{kycInfo?.personal_details?.corr_pin || kycInfo?.pan_details?.permanent_pincode || ""}</p>
                              </div>
                            </div>
                            <div className={`d-flex col-sm-12`}>
                              {/* <div className="text-success mt-2 me-2"><img src={`${APP_URL}/assets/img/Address.svg`} className="img-fluid w-75" alt="name" /></div> */}
                              <div className="badge rounded-pill bg-success bg-opacity-10 text-success px-3 py-3 me-2"><i class="fas fa-map-marker-alt"></i></div>
                              <div>
                                <p className="text-secondary small mb-0 text-start">Address</p>
                                <p className="fw-medium mb-0">{[
                                  kycInfo?.personal_details?.corr_line1 || kycInfo?.pan_details?.correspondence_address1 || kycInfo?.address || "",
                                  kycInfo?.personal_details?.corr_line2 || kycInfo?.pan_details?.correspondence_address2 || "",
                                  kycInfo?.personal_details?.corr_line3 || kycInfo?.pan_details?.correspondence_address3 || "",
                                  kycInfo?.personal_details?.corr_city || kycInfo?.pan_details?.correspondence_city || kycInfo?.city || "",
                                  kycInfo?.personal_details?.corr_state || kycInfo?.pan_details?.correspondence_state || kycInfo?.state || "",
                                  kycInfo?.personal_details?.corr_country || kycInfo?.pan_details?.correspondence_country || kycInfo?.country || ""
                                ].filter(Boolean).join(', ')}</p>
                              </div>
                            </div>
                          </div>

                          <div className="text-center">
                            <button
                              type="submit"
                              className="btn btn-success btn-md mt-3"
                              onClick={() => {
                                setShowkyc(false);
                                toast.success("Your Service Activated")
                                setActiveShow(true);
                              }}
                            >
                              Activate Now
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-3"></div>
                    </>
                  )}
                  {activeShow && (
                    <>
                      {/* <div className="col-md-3"></div> */}
                      <div className={isDark ? "welcome-hero-dark welcome-hero-dark-border col-md-6 card text-center rounded-3" : "welcome-hero-light-section welcome-hero-light-border col-md-6 card text-center rounded-3"}>
                        {console.log(kycInfo.isCompleted)}
                        {kycInfo.isCompleted ?
                          <div className="card-body">
                            <h4 className="fw-bold mt-2 text-success">Congratulations  </h4>
                            <p>
                              <small className="fw-semibold">Your {PaymentData?.cartItems[0].name || PaymentData?.bundleName} Service has been activated!</small>
                            </p>
                            <div className="">


                              <div className="my-3">
                                <img src={`${APP_URL}/assets/img/activate.svg`} alt="activate" />
                              </div>

                              <p className="mb-2">
                                <small>Please download our app to get instant service alerts.</small>
                              </p>

                              <div className="d-flex justify-content-center gap-2 mb-3">
                                <a
                                  target="_blank"
                                  href="https://play.google.com/store/apps/details?id=com.equitypandit.live"
                                  className="btn"
                                >

                                  <img src={`${APP_URL}/assets/img/android-app.png`} alt="Google Play" style={{ height: '40px' }} />
                                </a>
                                <a
                                  target="_blank"
                                  href="https://apps.apple.com/in/app/equitypandit-lite/id6444849307"
                                  className="btn "
                                > <img src={`${APP_URL}/assets/img/app-store.png`} alt="App Store" style={{ height: '40px' }} />
                                </a>
                              </div>
                              <div className="d-flex justify-content-center gap-2 mb-3">
                                <button type="button" className="btn btn-outline-success btn-sm rounded-1 me-2" onClick={() => {
                                  setActiveShow(false)
                                  localStorage.removeItem("pid");
                                  setIsLastPaymentSuccess(false);
                                  setHasPaymentId("0");
                                  navigate("/dashboard")
                                }}>
                                  <i class="fa-solid fa-arrow-left me-2"></i> Back To Dashboard
                                </button>
                              </div>
                            </div>
                          </div>
                          :
                          <div className="card-body">
                            <h4 className="fw-bold mt-2 text-warning">Your Kyc is Pending</h4>
                            <p>
                              <small className="fw-semibold">For activate {PaymentData?.cartItems[0].name || PaymentData?.bundleName} service contact us below</small>
                            </p>
                            <div className="">
                              <p>You can send your KYC at <b>kyc@equitypandit.com</b></p>
                              OR
                              {/* <p>Upload your kyc from <a href="/upload-documents" className="fw-bold"> upload docs</a>.</p> */}
                              <p>Contact To Support at <b>+91 8000 816 688</b> / <b>7574 838 8892</b> </p>
                            </div>
                          </div>
                        }
                      </div>
                      {/* <div className="col-md-3"></div> */}
                    </>
                  )}
                </>
              ) :
                <>
                  <div className="col-md-6 card text-center rounded-3 d-none">
                    <div className="card-body">
                      {/* <div className="col-12  text-center bg-secondary-subtle py-2">
                    Your KYC details are up to date.
                  </div> */}
                    </div>
                  </div>
                  {showkyc && (
                    <>
                      <div className={isDark ? "welcome-hero-dark welcome-hero-dark-border col-md-10 card text-center rounded-3" : "welcome-hero-light-section welcome-hero-light-border card text-center rounded-3"}>
                        <div className={"card-body"}>
                          <h4 className="fw-bold mt-2">KYC Details </h4>
                          <p>
                            <small className="fw-semibold d-none">Please confirm your details</small>
                          </p>
                          <div class="row g-4 mb-3">
                            <div className={`d-flex col-sm-6`}>
                              {/* <div className="text-primary mt-2 me-2"><img src={`${APP_URL}/assets/img/Name.svg`} className="img-fluid w-75" alt="name" /></div> */}
                              <div className="badge rounded-pill bg-primary bg-opacity-10 text-primary px-3 py-3 me-2"><i className="fas fa-user"></i></div>
                              <div>
                                <p className="text-secondary small mb-0 text-start">Name</p>
                                <p className="fw-medium mb-0">{kycInfo?.personal_details?.full_name || kycInfo?.name || ""}</p>
                              </div>
                            </div>
                            <div className={`d-flex col-sm-6`}>
                              {/* <div className="text-primary mt-2 me-2"><img src={`${APP_URL}/assets/img/Email.svg`} className="img-fluid w-75" alt="name" /></div> */}
                              <div className="badge rounded-pill bg-primary bg-opacity-10 text-primary px-3 py-3 me-2"><i className="fas fa-envelope"></i></div>
                              <div>
                                <p className="text-secondary small mb-0 text-start">Email</p>
                                <p className="fw-medium mb-0">{kycInfo?.personal_details?.email || kycInfo?.pan_details?.email_address || kycInfo?.kycObj?.pan_details?.email_address || kycInfo?.email}</p>
                              </div>
                            </div>
                            <div className={`d-flex col-sm-6`}>
                              {/* <div className="text-primary mt-2 me-2"><img src={`${APP_URL}/assets/img/PAN.svg`} className="img-fluid w-75" alt="name" /></div> */}
                              <div className="badge rounded-pill bg-primary bg-opacity-10 text-primary px-3 py-3 me-2"><i class="fas fa-address-card"></i></div>
                              <div>
                                <p className="text-secondary small mb-0 text-start">Pan</p>
                                <p className="fw-medium mb-0">{kycInfo?.personal_details?.pan || kycInfo?.pan || kycInfo?.pan_number || "BUGPS8049MTEST"}</p>
                              </div>
                            </div>
                            <div className={`d-flex col-sm-6`}>
                              {/* <div className="text-primary mt-2 me-2"><img src={`${APP_URL}/assets/img/DateOfBirth.svg`} className="img-fluid w-75" alt="name" /></div> */}
                              <div className="badge rounded-pill bg-primary bg-opacity-10 text-primary px-3 py-3 me-2"><i class="fas fa-calendar-alt"></i></div>
                              <div>
                                <p className="text-secondary small mb-0 text-start">Date Of Birth</p>
                                <p className="fw-medium mb-0">{kycInfo?.personal_details?.dob || kycInfo?.kycObj?.pan_details?.dob || kycInfo?.pan_details?.dob || kycInfo?.dob || "01/01/2000"}</p>
                              </div>
                            </div>
                            <div className={`d-flex col-sm-6`}>
                              {/* <div className="text-primary mt-2 me-2"><img src={`${APP_URL}/assets/img/MobileNo.svg`} className="img-fluid w-75" alt="name" /></div> */}
                              <div className="badge rounded-pill bg-primary bg-opacity-10 text-primary px-3 py-3 me-2"><i class="fas fa-phone-alt"></i></div>
                              <div>
                                <p className="text-secondary small mb-0 text-start">Mobile No</p>
                                <p className="fw-medium mb-0">{kycInfo?.personal_details?.mob_no || kycInfo?.kycObj?.pan_details?.mobile_number || kycInfo?.pan_details?.mobile_number || kycInfo?.mobile || "01/01/2000"}</p>
                              </div>
                            </div>
                            <div className={`d-flex col-sm-6`}>
                              {/* <div className="text-primary mt-2 me-2"><img src={`${APP_URL}/assets/img/PinCode.svg`} className="img-fluid w-75" alt="name" /></div> */}
                              <div className="badge rounded-pill bg-primary bg-opacity-10 text-primary px-3 py-3 me-2"><i class="fas fa-map-pin fa-lg"></i></div>
                              <div>
                                <p className="text-secondary small mb-0 text-start">Pin Code</p>
                                <p className="fw-medium mb-0 text-start">{kycInfo?.personal_details?.corr_pin || kycInfo?.pan_details?.permanent_pincode || kycInfo?.kycObj?.pan_details?.permanent_pincode || kycInfo?.kycObj?.download_response?.personal_details?.corr_pin || "-"}</p>
                              </div>
                            </div>
                            <div className={`d-flex col-sm-12 align-items-start`}>
                              {/* <div className="text-primary mt-2 me-2"><img src={`${APP_URL}/assets/img/Address.svg`} className="img-fluid w-75" alt="name" /></div> */}
                              <div className="badge rounded-pill bg-primary bg-opacity-10 text-primary p-3 me-2"><i class="fas fa-map-marker-alt"></i></div>
                              <div>
                                <p className="text-secondary small mb-0 text-start">Address</p>
                                <p className="fw-medium mb-0 text-start">{[
                                  kycInfo?.personal_details?.corr_line1 || kycInfo?.kycObj?.pan_details?.permanent_address1 || kycInfo?.pan_details?.permanent_address1 || kycInfo?.kycObj?.download_response?.personal_details?.corr_line1 || "",
                                  kycInfo?.personal_details?.corr_line2 || kycInfo?.kycObj?.pan_details?.permanent_address2 || kycInfo?.pan_details?.permanent_address2 || kycInfo?.kycObj?.download_response?.personal_details?.corr_line2 || "",
                                  kycInfo?.personal_details?.corr_line3 || kycInfo?.kycObj?.pan_details?.permanent_address3 || kycInfo?.pan_details?.permanent_address3 || kycInfo?.kycObj?.download_response?.personal_details?.corr_line3 || "",
                                  kycInfo?.personal_details?.corr_city || kycInfo?.kycObj?.pan_details?.permanent_city || kycInfo?.pan_details?.permanent_city || kycInfo?.kycObj?.download_response?.personal_details?.corr_city || kycInfo?.city || "",
                                  kycInfo?.personal_details?.corr_state || kycInfo?.kycObj?.pan_details?.permanent_state || kycInfo?.pan_details?.permanent_state || kycInfo?.kycObj?.download_response?.personal_details?.corr_state || kycInfo?.state || "",
                                  kycInfo?.personal_details?.corr_country || kycInfo?.kycObj?.pan_details?.permanent_country || kycInfo?.pan_details?.permanent_country || kycInfo?.kycObj?.download_response?.personal_details?.corr_country || kycInfo?.country || ""
                                ].filter(Boolean).join(', ')}</p>
                              </div>
                            </div>
                            {!(userDetail.rpfProfileType && authState) && (
                              <div className="text-center text-danger ">
                                <span>
                                  <b>{hasErrorMessage}</b>
                                </span>
                                <br />
                                <Link to="/risk-profile">
                                  Please complete your risk profile first.{" "}
                                  <LinkIcon size={15} />
                                </Link>
                              </div>
                            )}
                            {/* <div className="text-center">

                            <button
                              type="button"
                              onClick={() => { navigate("/dashboard"); localStorage.removeItem("kyc") }}
                              className="btn btn-success text-center btn-sm mt-2"
                              disabled={
                                (!userDetail.rpfProfileType && authState)
                              }
                            >
                              Go to Dashboard
                            </button>
                          </div> */}
                            <div className="text-center">
                              {/* {<button
                                type="submit"
                                className="btn btn-primary "
                                onClick={() => {
                                  requestSignDocument(JSON.parse(storedData))
                                    .then((response) => {
                                      buttonRef.current?.click();
                                      setRequestSignData(response.data.data);
                                      localStorage.removeItem("kyc")
                                    })
                                    .catch((e) => {
                                      alert(e.response?.data?.message);
                                    });
                                }}
                              >
                                Sign Now <i class="fa-solid fa-arrow-right"></i>
                              </button>} */}
                              {JSON.parse(localStorage.getItem("czSignPayload")) !== null &&
                                <button
                                  type="submit"
                                  className={`${primaryThemeButtonClass} mt-3`}
                                  style={primaryThemeButtonStyle}
                                  disabled={
                                    paymentLoading || // ⬅️ block button until PaymentData resolved                                  
                                    (!userDetail.rpfProfileType && authState)
                                  }
                                  onClick={() => {
                                    if (PaymentData) {
                                      setInitializeCashfree(true);
                                      paymentOnCashFree(paymentId, data.IsRecurringOptionOpen).then((response) => {
                                        if (response?.data?.status) {
                                          if (data.IsRecurringOptionOpen) {
                                            doPayment(response.data?.data?.subscription_session_id, paymentId, data.IsRecurringOptionOpen);
                                          } else {
                                            doPayment(response.data?.data?.payment_session_id);
                                          }
                                        }
                                      });
                                    } else {
                                      requestSignDocument(getSignPayload())
                                        .then((response) => {
                                          buttonRef.current?.click();
                                          setRequestSignData(response.data.data);
                                          localStorage.removeItem("kyc")
                                        })
                                        .catch((e) => {
                                          alert(e.response?.data?.message);
                                        });
                                    }
                                  }}
                                >
                                  {console.log(PaymentData)}
                                  {paymentLoading
                                    ? "Checking..."
                                    : PaymentData
                                      ? "Pay Now"
                                      : "E-Sign Now"}
                                </button>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  {showKycForm && (
                    <>
                      {/* <div className="col-md-3"></div> */}
                      <div className={isDark ? "welcome-hero-dark welcome-hero-dark-border col-md-6 card text-center rounded-3" : "welcome-hero-light-section welcome-hero-light-border col-md-6 card text-center rounded-3"}>
                        <div className="card-body">
                          {/* <h4 className="fw-bold mt-2">Complete Your KYC Now</h4> */}
                          <h4 className="fw-bold mt-2">Enter Your Details</h4>
                          <p className="d-none">
                            <small>({PaymentData?.packageFirebaseName} - {PaymentData?.duration}  {PaymentData?.durationType})</small>
                          </p>
                          <div className="row">
                            <Formik
                              initialValues={{
                                // userId: userDetail.id,
                                // ckycNo: "-",
                                name: userDetail.firstName,
                                // email: userDetail.email,
                                mobile: userDetail.mobile,
                                // dob: userDetail.dob,
                                dob: "",
                                pan: "",
                                otp: "",
                                // address: "",
                                // city: "",
                                // state: "",
                                // country: "INDIA",
                                // isCompleted: true,
                              }}
                              validationSchema={validationSchemaKyc(VerifyOtp, fallbackFlow)}
                              onSubmit={async (values, { setSubmitting }) => {
                                setSubmitting(false);
                                setShowLoader(true);
                                let resp
                                try {
                                  if (!VerifyOtp && !fallbackFlow) {
                                    let searchParams = {
                                      "pan": values.pan,
                                      "mobile": values.mobile,
                                    }
                                    try {
                                      resp = await axiosInstance.post(`${V1_API_ORIGIN}/kyc/send-otp`, searchParams);
                                      setRequestId(resp.data?.data?.request_id)
                                      toast.success("OTP sent successfully");
                                      setShowLoader(false)
                                      setVerifyOtp(true); // switch to OTP flow
                                    } catch (err) {
                                      // FALLBACK: Direct KYC API
                                      const fallbackParams = {
                                        name: values.name,
                                        userId: localStorage.getItem("uid"),
                                        pan: values.pan,
                                        mobile: values.mobile,
                                        email: userDetail.email,
                                        // dob: moment(values.dob).format("DD/MM/YYYY"),
                                        dob: moment(values.dob).format("YYYY/MM/DD"),
                                      };

                                      // const res = await axiosInstance.post(
                                      //   `${V1_API_ORIGIN}/kyc/fetch`,
                                      //   fallbackParams
                                      // );
                                      const res = await axiosInstance.post(
                                        `${V1_API_ORIGIN}/kyc`,
                                        fallbackParams
                                      );

                                      // toast.success("KYC data fetched successfully");
                                      toast.success("Proceed with E-Sign");
                                      setKycInfo(res.data.data)
                                      // setShowkyc(true)
                                      setShowKycForm(false)
                                      requestSignDocument(getSignPayload())
                                        .then((response) => {
                                          setFallbackFlow(true); // no OTP verification needed
                                          buttonRef.current?.click();
                                          setRequestSignData(response.data.data);
                                          setShowLoader(false)
                                          localStorage.removeItem("kyc")
                                        })
                                        .catch((e) => {
                                          alert(e.response?.data?.message);
                                        });
                                    }
                                  } else if (VerifyOtp && !fallbackFlow) {
                                    // STEP 2: VERIFY OTP
                                    let verifyParams = {
                                      userId: userDetail.id,
                                      request_id: RequestId,
                                      otp: values.otp,
                                    };
                                    const res = await axiosInstance.post(
                                      `${V1_API_ORIGIN}/kyc/verify-otp`,
                                      verifyParams,
                                      {
                                        headers: {
                                          "Content-Type": "application/json",
                                          "Authorization": `Bearer ${token}`,
                                        }
                                      }
                                    );

                                    toast.success("KYC verified successfully");
                                    setShowkyc(true)
                                    setKycInfo(res.data.data)
                                    setShowKycForm(false)
                                    setShowLoader(false)
                                  }
                                } catch (err) {
                                  setErrorMessage(err?.response?.data?.message || "Something went wrong");
                                  setShowModal(true);
                                  setShowLoader(false);
                                } finally {
                                  setShowLoader(false);
                                }
                              }}
                              enableReinitialize
                            >
                              {({ isSubmitting, touched, errors, values }) => (
                                <Form>
                                  <div className="row g-3 justify-content-center">
                                    {/* {hasKycData?.id && (
                                    <div className="col-12  text-center bg-secondary-subtle py-2">
                                      Your KYC details are up to date.
                                    </div>
                                  )} */}
                                    <div className="col-md-7">
                                      <small className="d-block text-muted">Name <small>(as per Pan Card)</small> </small>
                                      <Field
                                        name="name"
                                        className={`form-control form-control-sm mt-1 ${touched.name && errors.name && "is-invalid"
                                          }`}
                                        value={values.name || ""}
                                      />
                                      <ErrorMessage
                                        name="name"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                    <div className="col-md-6 d-none">
                                      <div className="form-floating mb-3">
                                        <small className="d-block text-muted">Email</small>
                                        <Field
                                          name="email"
                                          className={`form-control form-control-sm mt-1 ${touched.email && errors.email && "is-invalid"
                                            }`}
                                          value={values.email || ""}
                                        />
                                        <ErrorMessage
                                          name="email"
                                          component="div"
                                          className="invalid-feedback"
                                        />
                                      </div>
                                    </div>

                                    <div className="col-md-6 ">

                                      <small className="d-block text-muted me-1">PAN Card Number* <button type="button " className="border-0 btn btn-sm" data-bs-toggle="modal" data-bs-target="#PanKycModal"><i className="fa-solid fa-circle-question ms-1"></i></button></small>
                                      <Field
                                        name="pan"
                                        className={`form-control form-control-sm mt-1 ${touched.pan && errors.pan && "is-invalid"}`}
                                        value={values.pan || hasKycData?.pan || ""}
                                        disabled={VerifyOtp || fallbackFlow}
                                      ></Field>
                                      <ErrorMessage
                                        name="pan"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                  </div>
                                  <div className="row mt-1 g-3 justify-content-center">
                                    <div className="col-md-6">

                                      <small className="d-block text-muted">Mobile *</small>
                                      <Field
                                        name="mobile"
                                        disabled={VerifyOtp || fallbackFlow}
                                        className={`form-control form-control-sm mt-1 ${touched.mobile && errors.mobile && "is-invalid"
                                          }`}
                                        value={values.mobile || ""}
                                      />
                                      <ErrorMessage
                                        name="mobile"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                  </div>
                                  <div className="row mt-1 g-3 justify-content-center">
                                    <div className="col-md-6 ">
                                      <small className="d-block text-muted">Date Of Birth (dd/mm/yyyy)*</small>
                                      <Field
                                        name="dob"
                                        type="date"
                                        disabled={VerifyOtp || fallbackFlow}
                                        className={`form-control form-control-sm mt-1 ${touched.dob && errors.dob && "is-invalid"
                                          }`}
                                        value={values.dob || ""}
                                      />
                                      <ErrorMessage
                                        name="dob"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>

                                    <div className="col-md-6 d-none">
                                      <small className="d-block text-muted">Country</small>
                                      <Field
                                        as="select"
                                        name="country"
                                        className={`form-control form-control-sm mt-1 ${touched.country && errors.country && "is-invalid"
                                          }`}
                                        value={values.country || ""}
                                      >
                                        <option value="">-- Select --</option>
                                        <option value="INDIA">INDIA</option>
                                        <option value="other">OTHER</option>
                                      </Field>
                                    </div>
                                    {["INDIA"].includes(values.country) ? (
                                      <div className="col-md-6 d-none">
                                        <small className="d-block text-muted">State</small>
                                        <Field
                                          as="select"
                                          name="state"
                                          className={`form-control form-control-sm mt-1 ${touched.state && errors.state && "is-invalid"
                                            }`}
                                          value={values.state || ""}
                                        >
                                          <option value="">-- Select --</option>
                                          {states.map((item, index) => (
                                            <option value={item.value} key={index}>
                                              {item.text}
                                            </option>
                                          ))}
                                        </Field>
                                        <ErrorMessage
                                          name="state"
                                          component="div"
                                          className="invalid-feedback"
                                        />
                                      </div>
                                    ) : (
                                      <div className="col-md-6 d-none">
                                        <small className="d-block text-muted">Country</small>
                                        <Field
                                          name="country"
                                          className={`form-control form-control-sm mt-1 ${touched.country &&
                                            errors.country &&
                                            "is-invalid"
                                            }`}
                                          value={values.country || ""}
                                        />
                                        <ErrorMessage
                                          name="country"
                                          component="div"
                                          className="invalid-feedback"
                                        />
                                      </div>
                                    )}

                                    <div className="col-md-6 d-none">
                                      <small className="d-block text-muted">City</small>
                                      <Field
                                        name="city"
                                        className={`form-control form-control-sm mt-1 ${touched.city && errors.city && "is-invalid"
                                          }`}
                                        value={values.city || ""}
                                      />
                                      <ErrorMessage
                                        name="city"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                    {/* </div>
                                              <div className="row"> */}

                                    <div className="col-md-12 d-none">
                                      <small className="d-block text-muted">
                                        Full Address (as per document)
                                      </small>
                                      <Field
                                        name="address"
                                        as="textarea"
                                        rows="2"
                                        className={`form-control form-control-sm mt-1 ${touched.address && errors.address && "is-invalid"
                                          }`}
                                        value={values.address || hasKycData?.address || ""}
                                      ></Field>
                                      <ErrorMessage
                                        name="address"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                  </div>
                                  {/* OTP only if verifyOtp flow */}
                                  {VerifyOtp && !fallbackFlow && (
                                    <div className="row mt-1 g-3 justify-content-center">
                                      <div className="col-md-6 ">
                                        <small className="d-block text-muted">Enter OTP *</small>
                                        <Field
                                          name="otp"
                                          className={`form-control form-control-sm mt-1 ${touched.otp && errors.otp && "is-invalid"
                                            }`}
                                        />
                                        <ErrorMessage
                                          name="otp"
                                          component="div"
                                          className="invalid-feedback"
                                        />
                                      </div>
                                    </div>
                                  )}
                                  {!(userDetail.rpfProfileType && authState) && (
                                    <div className="text-center text-danger ">
                                      <span>
                                        <b>{hasErrorMessage}</b>
                                      </span>
                                      <br />
                                      <Link to="/risk-profile">
                                        Please complete your risk profile first.{" "}
                                        <LinkIcon size={15} />
                                      </Link>
                                    </div>
                                  )}
                                  <div className="col-12 mt-2 text-center">
                                    <div className="py-2">
                                      <small className="d-block d-none"><small className="text-muted">* I confirm that the information provided in this KYC form is true and accurate. I understand that false details may lead to delayed in service activation process. </small></small>
                                      <button
                                        type="submit"
                                        className="btn btn-md mt-3 "
                                        style={primaryButtonStyle}
                                        disabled={
                                          isSubmitting ||
                                          (!userDetail.rpfProfileType && authState)
                                        }
                                      >
                                        {isSubmitting ? "Loading..." : "Continue"}
                                        {/* {!isSubmittin} */}
                                        {/* <i className="bi bi-arrow-right"></i> */}
                                      </button>
                                    </div>
                                  </div>
                                </Form>
                              )}
                            </Formik>
                          </div>
                        </div>
                      </div>
                      {/* <div className="col-md-3"></div> */}
                    </>
                  )}
                  {activeShow && (
                    <>
                      {/* <div className="col-md-3"></div> */}
                      <div className={isDark ? "welcome-hero-dark welcome-hero-dark-border col-md-6 card text-center rounded-3" : "welcome-hero-light-section welcome-hero-light-border col-md-6 card text-center rounded-3"}>
                        {kycInfo.isCompleted ?
                          <div className="card-body">
                            <h4 className="fw-bold mt-2 text-success">Congratulations222 </h4>
                            <p>
                              <small className="fw-semibold">Your {PaymentData?.cartItems[0].name || PaymentData?.bundleName} Service has been activated!</small>
                            </p>
                            <div className="">


                              <div className="my-3">
                                <img src={`${APP_URL}/assets/img/activate.svg`} alt="activate" />
                              </div>

                              <p className="mb-2">
                                <small>Please download our app to get instant service alerts.</small>
                              </p>

                              <div className="d-flex justify-content-center gap-2 mb-3">
                                <a
                                  target="_blank"
                                  href="https://play.google.com/store/apps/details?id=com.equitypandit.live"
                                  className="btn"
                                >

                                  <img src={`${APP_URL}/assets/img/android-app.png`} alt="Google Play" style={{ height: '40px' }} />
                                </a>
                                <a
                                  target="_blank"
                                  href="https://apps.apple.com/in/app/equitypandit-lite/id6444849307"
                                  className="btn "
                                > <img src={`${APP_URL}/assets/img/app-store.png`} alt="App Store" style={{ height: '40px' }} />
                                </a>
                              </div>
                              <div className="d-flex justify-content-center gap-2 mb-3">
                                <button type="button" className="btn btn-outline-success btn-sm rounded-1 me-2" onClick={() => {
                                  setActiveShow(false)
                                  localStorage.removeItem("pid");
                                  setIsLastPaymentSuccess(false);
                                  setHasPaymentId("0");
                                  navigate("/dashboard")
                                }}>
                                  <i class="fa-solid fa-arrow-left me-2"></i> Back To Dashboard
                                </button>
                              </div>
                            </div>
                          </div>
                          :
                          <div className="card-body">
                            <h4 className="fw-bold mt-2 text-warning">Your Kyc is Pending</h4>
                            <p>
                              <small className="fw-semibold">For activate {PaymentData?.cartItems[0].name || PaymentData?.bundleName} service contact us below</small>
                            </p>
                            <div className="">
                              <p>You can send your KYC at <b>kyc@equitypandit.com</b></p>
                              OR
                              {/* <p>Upload your kyc from <a href="/upload-documents" className="fw-bold"> upload docs</a>.</p> */}
                              <p>Contact To Support at <b>+91 8000 816 688</b> / <b>7574 838 8892</b> </p>
                            </div>
                          </div>
                        }
                      </div>
                      {/* <div className="col-md-3"></div> */}
                    </>
                  )}
                </>
              }
            </div>
          </div>
          <div
            className="modal fade"
            id="service_process"
            tabIndex="-1"
            aria-labelledby="service_processLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-md modal-confirm modal-dialog-centered">
              <div className="modal-content table">
                <div className="modal-header">
                  <h5 className="modal-title fw-bold">KYC Form</h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    ref={buttonRef}
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="row">
                    <Formik
                      initialValues={{
                        userId: userDetail.id,
                        ckycNo: "-",
                        name: userDetail.firstName,
                        email: userDetail.email,
                        mobile: userDetail.mobile,
                        dob: userDetail.dob,
                        address: "",
                        city: "",
                        state: "",
                        country: "INDIA",
                        pan: "",
                        isCompleted: true,
                      }}
                      validationSchema={validationSchemaKyc}
                      onSubmit={async (values, { setSubmitting }) => {
                        setSubmitting(false);
                        await axiosInstance.post(`${V1_API_ORIGIN}/kyc`, values);
                        let uid = '';
                        if (typeof window !== 'undefined') {
                          uid = localStorage.getItem("uid");
                        }
                        axiosInstance
                          .get(`${V1_API_ORIGIN}/kyc/get-by-userId/${uid}`)
                          .then((response) => {
                            setHasKycData(response.data.data);
                          })
                          .then(() => {
                            buttonRef.current.click();
                          });
                      }}
                      enableReinitialize
                    >
                      {({ isSubmitting, touched, errors, values }) => (
                        <Form>
                          <div className="row g-3">
                            {hasKycData?.id && (
                              <div className="col-12  text-center bg-secondary-subtle py-2">
                                Your KYC details are up to date.
                              </div>
                            )}
                            <div className="col-md-6">
                              <small className="d-block text-muted">Name</small>
                              <Field
                                name="name"
                                className={`form-control form-control-sm mt-1 ${touched.name && errors.name && "is-invalid"
                                  }`}
                                value={values.name || ""}
                              />
                              <ErrorMessage
                                name="name"
                                component="div"
                                className="invalid-feedback"
                              />
                            </div>
                            <div className="col-md-6 ">
                              <small className="d-block text-muted">Mobile</small>
                              <Field
                                name="mobile"
                                className={`form-control form-control-sm mt-1 ${touched.mobile && errors.mobile && "is-invalid"
                                  }`}
                                value={values.mobile || ""}
                              />
                              <ErrorMessage
                                name="mobile"
                                component="div"
                                className="invalid-feedback"
                              />
                            </div>
                            <div className="col-md-6 ">
                              <small className="d-block text-muted">Email</small>
                              <Field
                                name="email"
                                className={`form-control form-control-sm mt-1 ${touched.email && errors.email && "is-invalid"
                                  }`}
                                value={values.email || ""}
                              />
                              <ErrorMessage
                                name="email"
                                component="div"
                                className="invalid-feedback"
                              />
                            </div>
                            <div className="col-md-6 ">
                              <small className="d-block text-muted">DOB</small>
                              <Field
                                name="dob"
                                type="date"
                                className={`form-control form-control-sm mt-1 ${touched.dob && errors.dob && "is-invalid"
                                  }`}
                                value={values.dob || ""}
                              />
                              <ErrorMessage
                                name="dob"
                                component="div"
                                className="invalid-feedback"
                              />
                            </div>
                            <div className="col-md-6 col-12">
                              <small className="d-block text-muted">PAN</small>
                              <Field
                                name="pan"
                                className={`form-control form-control-sm mt-1 ${touched.pan && errors.pan && "is-invalid"
                                  }`}
                                value={values.pan || hasKycData?.pan || ""}
                              ></Field>
                              <ErrorMessage
                                name="pan"
                                component="div"
                                className="invalid-feedback"
                              />
                            </div>
                            <div className="col-md-6 ">
                              <small className="d-block text-muted">Country</small>
                              <Field
                                as="select"
                                name="country"
                                className={`form-control form-control-sm mt-1 ${touched.country && errors.country && "is-invalid"
                                  }`}
                                value={values.country || ""}
                              >
                                <option value="">-- Select --</option>
                                <option value="INDIA">INDIA</option>
                                <option value="other">OTHER</option>
                              </Field>
                            </div>
                            {["INDIA"].includes(values.country) ? (
                              <div className="col-md-6 ">
                                <small className="d-block text-muted">State</small>
                                <Field
                                  as="select"
                                  name="state"
                                  className={`form-control form-control-sm mt-1 ${touched.state && errors.state && "is-invalid"
                                    }`}
                                  value={values.state || ""}
                                >
                                  <option value="">-- Select --</option>
                                  {states.map((item, index) => (
                                    <option value={item.value} key={index}>
                                      {item.text}
                                    </option>
                                  ))}
                                </Field>
                                <ErrorMessage
                                  name="state"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            ) : (
                              <div className="col-md-6 ">
                                <small className="d-block text-muted">Country</small>
                                <Field
                                  name="country"
                                  className={`form-control form-control-sm mt-1 ${touched.country &&
                                    errors.country &&
                                    "is-invalid"
                                    }`}
                                  value={values.country || ""}
                                />
                                <ErrorMessage
                                  name="country"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            )}

                            <div className="col-md-6 ">
                              <small className="d-block text-muted">City</small>
                              <Field
                                name="city"
                                className={`form-control form-control-sm mt-1 ${touched.city && errors.city && "is-invalid"
                                  }`}
                                value={values.city || ""}
                              />
                              <ErrorMessage
                                name="city"
                                component="div"
                                className="invalid-feedback"
                              />
                            </div>
                            {/* </div>
                        <div className="row"> */}

                            <div className="col-md-12">
                              <small className="d-block text-muted">
                                Full Address (as per document)
                              </small>
                              <Field
                                name="address"
                                as="textarea"
                                rows="2"
                                className={`form-control form-control-sm mt-1 ${touched.address && errors.address && "is-invalid"
                                  }`}
                                value={values.address || hasKycData?.address || ""}
                              ></Field>
                              <ErrorMessage
                                name="address"
                                component="div"
                                className="invalid-feedback"
                              />
                            </div>
                          </div>
                          {!(userDetail.rpfProfileType && authState) && (
                            <div className="text-center text-danger">
                              <span>
                                <b>{hasErrorMessage}</b>
                              </span>
                              <br />
                              <Link to="/risk-profile">
                                Please complete your risk profile first.{" "}
                                <LinkIcon size={15} />
                              </Link>
                            </div>
                          )}
                          <div className="col-12 ">
                            <div className="py-2">
                              <small className="d-block"><small className="text-muted">* I confirm that the information provided in this KYC form is true and accurate. I understand that false details may lead to delayed in service activation process. </small></small>
                              <button
                                type="submit"
                                className="btn btn-success btn-md mt-3"
                                disabled={
                                  isSubmitting ||
                                  (!userDetail.rpfProfileType && authState)
                                }
                              >
                                {isSubmitting ? "Loading..." : "Submit"}
                                {/* {!isSubmittin} */}
                                {/* <i className="bi bi-arrow-right"></i> */}
                              </button>
                            </div>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal fade" id="PanKycModal" tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title fs-6" id="PanKycModalLabel">Why pan card is required?</h5>
                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div className="modal-body">
                  <small>PAN Card is require for KYC as per SEBI Guidelines</small>
                </div>
                <div className="modal-footer d-none">
                  <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                  <button type="button" className="btn btn-primary">Save changes</button>
                </div>
              </div>
            </div>
          </div>
          {ShowModal && (
            <div
              className="modal fade show d-block"
              tabIndex="-1"
              style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header bg-warning bg-opacity-75">
                    <h6 class="modal-title d-flex align-items-center" id="kycErrorModalLabel">
                      <i class="fas fa-exclamation-triangle me-2"></i> KYC Details Fetch Failed
                    </h6>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setShowModal(false)}
                    ></button>
                  </div>
                  <div className="modal-body text-center">
                    <p class="mb-3">
                      We couldn't fetch your <strong>KYC details</strong> at the moment.<br />
                      Our support team will contact you shortly.
                    </p>
                    <div class="alert alert-light border text-center">
                      <small>If you still have any query, you can reach us directly at:</small>

                      <small class="mb-1 d-block"><i class="fas fa-phone me-2"></i> <strong>Call us:</strong> +91-80008 16688</small>
                      <small class="mb-0"><i class="fas fa-envelope me-2"></i> <strong>Email:</strong> support@equitypandit.com</small>
                    </div>
                  </div>
                  <div className="modal-footer justify-content-center">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => setShowModal(false)}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </section>
        <Toaster />
      </Layout >
    </>
  );
}
